import { render, staticRenderFns } from "./plmInspectionSpec.vue?vue&type=template&id=ca6693ec&scoped=true"
import script from "./plmInspectionSpec.vue?vue&type=script&lang=js"
export * from "./plmInspectionSpec.vue?vue&type=script&lang=js"
import style0 from "./plmInspectionSpec.vue?vue&type=style&index=0&id=ca6693ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6693ec",
  null
  
)

export default component.exports